<template>
  <div id="indexREGOP_div">

    <menusuperior titulo="REGOP" subtitulo="Herramienta para registrar las solicitudes de ordenes de protección"></menusuperior>
    <!-- <menuizquierda></menuizquierda> -->

    <div class="content-area content-area__firma-multiple">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
 
  </div>
</template>
<script>
  import menusuperior from '@/components/Comunes/MenuSuperior.vue'
  import menuizquierda from '@/components/Comunes/MenuIzquierdaDeLosSistemas.vue'
  import comun from '@/../static/js/comun'

  export default {
    name: 'Plantilla',
    components: {
      menusuperior: menusuperior,
      menuizquierda: menuizquierda
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/REGOP/Comun/Plantilla.vue